"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("@/utils/axios"));
var _tree = require("@ys/utils/lib/tree");
var _test = require("@ys/utils/lib/test");
var _useReportSubjectEditor = require("./useReportSubjectEditor");
var _useCostItem = require("../CostItemTableTree/useCostItem");
var _default = exports.default = {
  name: 'SubjectEditCommonTemplate',
  // 智能报表-添加科目-添加或编辑弹框-从公共模板添加
  props: {
    operate: {
      type: String,
      default: 'add'
    },
    record: {
      type: Object,
      default: undefined
    },
    // 获取公共模板的接口链接或方法
    method: {
      type: [String, Function],
      default: '/v1/report/template/all'
    },
    // 额外的请求参数
    params: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      selectedIds: [],
      templateId: [],
      templateList: [],
      columns: [{
        title: '科目名称',
        dataIndex: 'name'
      }, {
        title: '科目类型',
        dataIndex: 'type',
        width: 150,
        customRender: (text, record) => (0, _useReportSubjectEditor.getSubjectType)(record.type, record.statType).text,
        customCell: record => ({
          class: (0, _useReportSubjectEditor.getSubjectType)(record.type, record.statType).color
        })
      }, {
        title: '统计维度',
        dataIndex: 'dimension',
        width: 120,
        customRender: text => _useCostItem.DIMENSION_MAP[this.params.dimension] || text,
        customCell: record => ({
          class: _useCostItem.DIMENSION_COLOR_MAP[this.params.dimension]
        })
      }],
      dataSource: [],
      defaultExpandedRowKeys: [],
      loading: false
    };
  },
  computed: {
    selectedTpl() {
      return this.templateList.filter(item => this.templateId.includes(item.id))[0] || {};
    }
  },
  watch: {
    selectedTpl: {
      handler(val) {
        if ((0, _test.isJsonString)(val?.content)) {
          const content = JSON.parse(val.content);
          // 过滤掉 show 为 false 的科目
          (0, _tree.removeNode)(content, node => node.show === false);
          this.dataSource = content;
          this.defaultExpandedRowKeys = content.map(item => item.id);
          this.selectedIds = [];
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getTplList();
  },
  methods: {
    // 获取模板列表
    async getTplList() {
      try {
        this.loading = true;
        const _params = {
          bizType: 'Report',
          type: '',
          source: 'Common'
        };
        const data = typeof this.method === 'function' ? await this.method({
          ..._params,
          ...this.params
        }) : await _axios.default.get(this.method, {
          ..._params,
          ...this.params
        });
        this.templateId = [data[0]?.id];
        this.templateList = data || [];
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    },
    rowSelectionChange({
      selectedRows,
      selectedTree
    }) {
      const {
        operate,
        record
      } = this;
      const time = new Date().getTime();
      const oldIdMap = {};
      let index = 1;

      // 模板的content可能不是树形结构，只返回selectedRows，故在此做兼容处理
      const target = selectedTree || selectedRows;

      // 遍历更新id和pid，确保不会在报表中出现相同id的节点
      (0, _tree.forEach)(target, node => {
        const oldId = node.id;

        // 更新id
        node.id = (time + index).toString();

        // 更新pid
        oldIdMap[oldId] = node.id;
        if (operate === 'add-child' && node.pid === _useReportSubjectEditor.ROOT_ID) {
          node.pid = record.id;
        } else {
          node.pid = oldIdMap[node.pid] || _useReportSubjectEditor.ROOT_ID;
        }

        // 删除forEach额外进入的字段
        delete node.level;
        delete node.selected;
        index++;
      });
      // target=> 最终插入的节点数组
      this.$emit('change', target);
    }
  }
};